import { Component, OnInit } from '@angular/core';
import {SelectItem} from 'primeng/api';
import { FacilityService, ReportsService,EquipmentService,
  SqacodeService,ModelService,MessageService, UserService } from 'src/app/services';
import { Router } from '@angular/router';
import { AccessUserInfo, UserDetail,LabReports } from 'src/app/models';
import { DatePipe } from '@angular/common'
import { ReportHeaderColumn } from 'src/app/models/report/ReportHeaderArray';
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
@Component({
  selector: 'bart-report-main',
  templateUrl: './report-main.component.html',
  styleUrls: ['./report-main.component.scss']
})

export class ReportMainComponent implements OnInit {
  datePipe = new DatePipe('en-US')
  userDetail :UserDetail  =null;
  popupWin:any;
  labresultReport: LabReports;
  reportId: any;
  reportURL: string;
  hideStatus: boolean = false;
  printPDFSubHeader: string =  "Final" ;
  constructor(private _FacilityService:FacilityService,
    private _ReportsService:ReportsService,
    private _EquipmentService:EquipmentService,
    private _SqacodeService:SqacodeService,
    private _Modelservice:ModelService,
    private router: Router,
    private _messageService:MessageService,
    private _userService: UserService
    ) {
      this.userDetail = AccessUserInfo.getUserInfo();
      this.signature = this.radioButtons[0]
   }

  ngOnInit()
  {
    this.GetUserLocations();
    this.GetReports();    
    this.populateGroupByLocation();
  }

  bartRoleId:null;
  public fieldDef:any[];
  public userLocationDivision: SelectItem[];
  public userLocationRegion: SelectItem[];
  public userLocationFacilities: SelectItem[];
  public pmReportType:SelectItem[];
  public groupByLocationItem:SelectItem[];
  public pmIntervalItem:SelectItem[];
  public pmReportsItem:SelectItem[];
  public equipmentItem:SelectItem[];
  public equipmentTypeItem:SelectItem[];
  public equipmentSubTypeItem:SelectItem[];
  public modelItem:SelectItem[];
  public reportFormatItem:SelectItem[];
  public equipmentStatusItem:SelectItem[];
  public sqaCodeItem:SelectItem[];
  public pacItem:SelectItem[];
  public viewResultByItem:SelectItem[];
  public testTypeItem:SelectItem[];
  public resultTypeItem:SelectItem[];
  public signatureItem:SelectItem[];
  public deviceItem:SelectItem[];
  public FacilityDisplayName:string;
  public divisionName:string;
  public reportDetails:any;
  private columnlist="inputparameterdescription,inputparameterinputtype,report_inputparameterhidden,report_inputparameterid,report_inputparameterlabel,report_inputparameterparent,report_inputparameterrequired";

   public reportMenuStruct:any;
   public reportTitle:string;
   public hiddenReportId:number;
   public hiddenReportOrder:number;
   public hiddenIsPDFReportFormat:boolean=false;
   public selectedGroupLocation: string;
   public selectedReportFormat:string = "PDF";
   public selectedEquipmentStatusId:number;
   public selectedsqaCode:number
   public selectedEquipmentSubTypeId:number;
   public selectedFacilityMasterId:number = null;
  public locData:any;
  public selectedEquipmentTypeId:number=0;
  public selectedDivisionMasterId:number;
  public selectedRegionmasterId:number;
  public selectedEquipmentId:number;
  public SelectedPmReportType:string;
  public selectedModelId:number;
  public selectedPmIntervalId:number;
  public selectedPacId:number;
  public selectedDeviceIds:any[];
  public showDateRange:boolean=false;
  public resultRangeStartDt:Date=null;
  public resultRangeEndDt:Date=null;
  public selectedViewResultBy:string="Last 6 Months";
  public selectedTestType:string="All";
  public selectedResultType = "Final";
  public printPDF:boolean=false;
  public showSignatureSection:boolean=false;
  public showDateRageForPDF : string;
  showSignatureSectionOnPDF : boolean = true
  radioButtons: any[] = [{ name: 'Yes', value: true }, { name: 'No', value: false }];
  signature : any;
  


getSQACodeParam=
{
  "GETSQACODES":
	{
	"allcodes":"1"
	}
}

getModelsParam=
{
	"GETMODELS":
	{
	"equipmentTypeId":this.selectedEquipmentTypeId
	}
}

getEquipmentSubTypeParam=
{
  "GETEQUIPMENTSUBTYPES":
  {
    "equipmenttypeid":this.selectedEquipmentTypeId
  }
}

getEquipmentParam=
{"GETFACILITYEQUIPMENTLIST":
  {
    "facilityMasterId":this.selectedFacilityMasterId
  }
}

  reportButtonSelect(evt){

    document.getElementById('pnlReportFooter').style.display='block';
    document.getElementById('runReport').style.display='none';
    document.getElementById('dvReportFormat').style.display='none';
    this.showSignatureSection=false;

     this.selectedGroupLocation="Facility";
    this.selectedEquipmentStatusId=null;
    this.selectedsqaCode=null
    this.selectedEquipmentSubTypeId=null;
    this.selectedFacilityMasterId=null;
   this.selectedEquipmentTypeId=null;
   this.selectedDivisionMasterId=null;
   this.selectedRegionmasterId=null;
   this.selectedEquipmentId=null;
   this.selectedModelId=null;
   this.selectedPacId=null;
   this.selectedDeviceIds=[];
   this.selectedViewResultBy="Last 6 Months";
   this.showDateRange=false;
   this.resultRangeStartDt=new Date(new Date().getFullYear(), new Date().getMonth(), 1);
   this.resultRangeEndDt=new Date();
   this.selectedTestType="All";
   this.selectedResultType = "Final";

   let tabButton,i;
   tabButton = document.getElementsByClassName("reportButton");
    for (i = 0; i < tabButton.length; i++) {
      tabButton[i].className = tabButton[i].className.replace(" active", "");
    }
    evt.currentTarget.className += " active";
    this.reportTitle=evt.currentTarget.text;
    this.hiddenReportId=evt.currentTarget.attributes.reportid.nodeValue;
    this.hiddenReportOrder=evt.currentTarget.attributes.reportorder.nodeValue;
    this.hiddenIsPDFReportFormat = JSON.parse(evt.currentTarget.attributes.isPDFReportFormat.nodeValue);
    document.getElementById('reportId').innerText= String(this.hiddenReportId);
    this.populateReportFormat();
    if(!this.hiddenIsPDFReportFormat){
      this.selectedReportFormat="On Screen";
    }
    else{
      this.populateViewResultsBy();
      this.selectedViewResultBy="Last 6 Months";
    }
    //this.userLocationDivision=[];
   this.userLocationFacilities=[];
   this.userLocationRegion=[];
      let fieldsParam=this.reportMenuStruct[Number(this.hiddenReportOrder)-1].reportFields.data;

      this.fieldDef=[];
      for(let countx=0; countx<this.reportMenuStruct[Number(this.hiddenReportOrder)-1].reportFields.recordscount;countx++)
      {
        let fieldHidden = parseInt(fieldsParam.report_inputparameterhidden[countx])
      if(fieldHidden != 1 ){
      let params = {
            inputParameterId:fieldsParam.report_inputparameterid[countx],
            description:fieldsParam.inputparameterdescription[countx],
            inputType:fieldsParam.inputparameterinputtype[countx],
            label:fieldsParam.report_inputparameterlabel[countx],
            parent:fieldsParam.report_inputparameterparent[countx],
            required:fieldsParam.report_inputparameterrequired[countx],
            fieldId:  'report' + fieldsParam.reportId + '_' + fieldsParam.inputparameterinputtype[countx]

        };
      this.fieldDef.push(this.fieldDefinition(params));
      }

      }

      
       //#region User Action Audit
      this._userService.logUserAction({
        userName: this.userDetail.userName,
        userAction: UserAction.REPORT_ITEM_CLICKED,
        screenName: ScreenName.REPORT,
        screenPath: location.pathname,
        key:'ReportID' ,
        value: evt.currentTarget.attributes.reportid.nodeValue,
        eventDescription: UserActionDescription.REPORT_MENU_CLICKED
      });
      //#endregion

  }

     fieldDefinition(params:any){
		let ret = {
		inputParameterId : params.inputParameterId,
		description : params.description,
		inputType : params.inputType.toLowerCase(),
		label : params.label,
		parent : params.parent,
		required : params.required,
    reportId : params.reportId,
    fieldId:params.fieldId
    }
		return ret;
	}

GetReports(){
  let reportorder:number[]=[];
  let reportstruct:any;
 let getReportParam=
{
"GETREPORT_INPUTPARAMETER": {
  "BartRoleID": this.userDetail.bartRoleId},
  "GETREPORT_BARTROLE": {
    "BartRoleID": this.userDetail.bartRoleId
  }
}
    if(getReportParam!=null)
    {
     let request =  getReportParam
      this._ReportsService.getReports(JSON.stringify(request) )
      .subscribe((reportResponse:any)=>{
        if(reportResponse!=null)
        {
          this.reportDetails=[];
          reportstruct=[];
          let r:any;
          let reportFields:any;
          let data:any;
          for(let i=0;i<reportResponse.GetReport_BartRoleResults.length;i++)
          {
            r="";
            r=reportResponse.GetReport_BartRoleResults[i];
            reportorder.push(r.reportId)
            reportstruct[i]=[];
            reportFields=[];
            data=[];

            let fields=reportResponse.GetReport_InputParameterResults.filter(x=>x.reportId===r.reportId);
              let report_inputParameterLabel:string[]=[];
              let inputparameterinputtype:string[]=[];
              let inputparameterdescription:string[]=[];
              let report_inputparameterparent:string[]=[];
              let report_inputparameterrequired:string[]=[];
              let report_inputparameterhidden:string[]=[];
              let report_inputparameterid:string[]=[];
             let requiredSum=0;
              for(let fld of fields)
              {
                report_inputParameterLabel.push(fld.report_inputParameterLabel);
                inputparameterinputtype.push(fld.inputParameterInputType);
                inputparameterdescription.push(fld.InputParameterDescription);
                report_inputparameterparent.push(fld.report_inputParameterParent);
                report_inputparameterrequired.push(fld.report_inputParameterRequired);
                report_inputparameterhidden.push(fld.report_inputParameterHidden);
                report_inputparameterid.push(fld.report_inputParameterId);
                if(fld.report_inputParameterRequired)
                {
                  requiredSum++;
                }
              }
              data.inputparameterinputtype=[];
              data.report_inputparameterlabel=report_inputParameterLabel;
              data.inputparameterinputtype=inputparameterinputtype;
              data.inputparameterdescription=inputparameterdescription;
              data.report_inputparameterparent=report_inputparameterparent;
              data.report_inputparameterrequired=report_inputparameterrequired;
              data.report_inputparameterhidden=report_inputparameterhidden;
              data.report_inputparameterid=report_inputparameterid;
              data.reportId=fields[0].reportId;
              data.requiredSum=requiredSum;

              reportstruct[i][0]=""+r.reportId+"";
              reportstruct[i].reportid=fields[0].reportId;
              reportstruct[i].reportname=fields[0].reportName;
              reportstruct[i].reportdescription=fields[0].reportDescription;
              reportstruct[i].isPDFReportFormat=r.IsPDFReportFormat;
              reportstruct[i].reportspname=fields[0].reportSpName
            reportstruct[i].reportFields=reportFields;
            reportstruct[i].reportFields.data=data;
            reportstruct[i].reportFields.recordscount=fields.length;
            reportstruct[i].reportFields.columnlist=this.columnlist;
            reportstruct[i].reportorder=i+1;
          }
          this.reportDetails.reportstruct=reportstruct;
          this.reportDetails.reportorder=reportorder;
          this.reportMenuStruct=reportstruct;
        }
    });
}


}

  GetUserLocations() {
   this.userLocationDivision=[];
let getLocationParam = {
  "GETUSERLOCATIONS":{
  "LOCATION_ID_LIST" : null,
  "USERNAME": this.userDetail.userName,
  },
  "GETUSERLOCATIONS2":{
    "USERNAME": this.userDetail.userName
  }
}
    if (getLocationParam != null) {

      this._FacilityService.getUserLocations(JSON.stringify(getLocationParam))
      .subscribe((allUserLocationsResponse: any) => {
        this.locData=allUserLocationsResponse;
         this.userLocationDivision = [];
        this.userLocationRegion=[];
        this.userLocationFacilities=[];
        this.populateDivisions();
        }, (respose: Response) => {
          this.userLocationDivision = [];
        this.userLocationRegion=[];
        this.userLocationFacilities=[];
        }
      );
    }

  }


  populateDivisions(){
    this.userLocationDivision=[];
    if(this.locData!=null && this.locData.divisions!=null && this.locData.divisions.length> 0) {
      this.userLocationDivision.push({ label: "", value:null});
      for (let c of this.locData.divisions) {
        this.userLocationDivision.push({ label: c.DivisionName, value:c.DivisionMasterID});
      }
      return this.userLocationDivision;
    }
    else{
      return this.userLocationDivision;
    }
  }


  populateRegions(evt){
    this.userLocationRegion=[];
    if(this.locData!=null && this.locData.regions!=null && this.locData.regions.length> 0) {
      this.userLocationRegion.push({ label: "", value:null});
        for (let c of this.locData.regions) {
          if(c.DivisionMasterID===evt.value){
            this.userLocationRegion.push({ label: c.RegionName, value:c.RegionMasterID});;
          }
        }
    }
  }

  populateFacilities(evt){
    this.userLocationFacilities=[];
    this.deviceItem=[];    
    if(this.locData!=null && this.locData.facilities!=null && this.locData.facilities.length> 0) {
      this.userLocationFacilities.push({ label: "", value:null});
        for (let c of this.locData.facilities) {
          if(c.RegionMasterID===evt.value){
            this.userLocationFacilities.push({ label: c.FacilityName, value:c.FacilityMasterID});;
          }
        }
    }
  }

  populateEquipment()
  {
    if(this.selectedFacilityMasterId){

      this.getEquipmentParam.GETFACILITYEQUIPMENTLIST.facilityMasterId=this.selectedFacilityMasterId;
      let request = this.getEquipmentParam;

      this._EquipmentService.getFacilityEquipmentList(JSON.stringify(request))
      .subscribe((getEquipmentResponse: any) => {
        this.equipmentItem=[];
        if(getEquipmentResponse.facilityEquipment!=null && getEquipmentResponse.facilityEquipment.length> 0){
         this.equipmentItem.push({label:"",value:null});
          for (let c of getEquipmentResponse.facilityEquipment) {
              let equipmentText="";
              equipmentText += c.ManufacturerName;
              equipmentText = equipmentText.trim() + ' - ';
              equipmentText += c.EquipmentSubTypeDescription;
              equipmentText = equipmentText.trim() + ' - ';
              equipmentText += c.ModelNumber;
              equipmentText = equipmentText.trim() + ' - ';
              equipmentText += c.EquipmentSerialNumber;
              equipmentText = equipmentText.trim();
            this.equipmentItem.push({ label:equipmentText, value:c.EquipmentId});
          }
        }
    });
  }
  }

  populateEquipmentType(){
    this._EquipmentService.getEquipmentTypes()
    .subscribe((getEquipmentResponse: any) => {
      this.equipmentTypeItem=[];
      if(getEquipmentResponse.equipmentType!=null && getEquipmentResponse.equipmentType.length> 0){
        this.equipmentTypeItem.push({label:"",value:null});
          for (let c of getEquipmentResponse.equipmentType) {
            this.equipmentTypeItem.push({ label:c.EquipmentTypeDescription, value:c.EquipmentTypeId});
          }
        }
    });
  }

  populateEquipmentStatus()
  {
    this._EquipmentService.getEquipmentStatus()
    .subscribe((getEquipmentstatusResponse: any) => {
         this.equipmentStatusItem=[];
         if(getEquipmentstatusResponse.status!=null && getEquipmentstatusResponse.status.length> 0){
          this.equipmentStatusItem.push({label:"",value:null});
            for (let c of getEquipmentstatusResponse.status) {
              this.equipmentStatusItem.push({ label:c.EquipmentStatusDescription, value:c.EquipmentStatusId});
            }
          }
    });
  }

  populateSqaCode()
  {
    let GETEQUIPMENTSQACODES = this.getSQACodeParam;
    this._SqacodeService.getSQACodes(JSON.stringify(GETEQUIPMENTSQACODES))
    .subscribe((sqaCodeRespose: any) => {
        this.sqaCodeItem=[];
        if(sqaCodeRespose.length> 0){
         this.sqaCodeItem.push({label:"",value:null});
           for (let c of sqaCodeRespose) {
             if(c.isActiveFlag==1){
                this.sqaCodeItem.push({ label:c.SQADescription, value:c.SQACodeId});
             }
           }
         }
    });
  }


  populatePmReportType() {
    this.pmReportsItem = [
      { value: 'Pending', label: 'Pending' },
      { value: 'Completed', label: 'Completed' },
      { value: 'Both', label: 'Both' }
    ];
    return this.pmReportsItem;
  }


  populateGroupByLocation() {
    this.groupByLocationItem = [
      { value: 'Facility', label: 'Location' },
      { value: 'Region', label: 'Region' },
      { value: 'Division', label: 'Division' },
      { value: 'Group', label: 'Group' }
    ];
    return this.groupByLocationItem;
  }


  populateReportFormat(){
    this.reportFormatItem=[];
    this.showSignatureSection=false;
    if(this.hiddenIsPDFReportFormat==true){
      this.reportFormatItem.push({value: 'PDF', label: 'PDF'});
      this.populateTestType();
      this.populateResultType();
      this.selectedReportFormat="PDF";
    }
    this.reportFormatItem.push({value: 'On Screen', label: 'On Screen'});
    this.reportFormatItem.push({value: 'Excel', label: 'Excel'});
  }

  //OneV-732258  Lab report pdf satrt
  populateDevices()
  {
    this.deviceItem=[]; 
    this.selectedDeviceIds=[];   
    if(this.selectedFacilityMasterId && this.hiddenIsPDFReportFormat){
      this.getEquipmentParam.GETFACILITYEQUIPMENTLIST.facilityMasterId=this.selectedFacilityMasterId;
      let request = this.getEquipmentParam;

      this._EquipmentService.getFacilityEquipmentList(JSON.stringify(request))
      .subscribe((getEquipmentResponse: any) => {
        if(getEquipmentResponse.facilityEquipment!=null && getEquipmentResponse.facilityEquipment.length> 0){
          getEquipmentResponse.facilityEquipment.splice(0,0,{MachineNickName: "All", EquipmentId:"All"})
         this.deviceItem = getEquipmentResponse.facilityEquipment.map(data => ({
         label: this.setEquipmentDisplayName(data),
         value: data.EquipmentId
       }));   
       this.selectedDeviceIds=[{label :"All",value: "All"}];
       this.checkRequiredFields();
        }
    });
  }  
  }

  setEquipmentDisplayName(data){
    if(data.EquipmentId=="All"){
      return data.MachineNickName;
    }
    let equipmentText:string="";
        equipmentText += (data.ModelNumber.length>0?data.ModelNumber+" | ":"- |");
        equipmentText += (data.MachineNickName.length>0?data.MachineNickName.substr(0,2)+" | ":" - | ");
        equipmentText += (data.EquipmentSerialNumber.length>0?data.EquipmentSerialNumber.substr(0,13)+" | ":" - | ");
        equipmentText += data.EquipmentId.toString().substr(0,7) ;
        equipmentText = equipmentText.trim();
    return equipmentText;
  }

  populateViewResultsBy(){
    this.viewResultByItem=[
      {value:'Last 6 Months',label:'Last 6 Months'},      
      {value:'Last Month',label:'Last Month'},
      {value:'Last 3 Months',label:'Last 3 Months'},
      {value:'Choose Date Range',label:'Choose Date Range'},
      {value:'Last 5 Results',label:'Last 5 Results'},
      {value:'Last 10 Results',label:'Last 10 Results'},
      {value:'Last 20 Results',label:'Last 20 Results'}
    ];
    return this.viewResultByItem;
  }

  onViewResultChange(evt){
    this.showDateRageForPDF="";
    this.showDateRange=false;
    this.resultRangeStartDt=null;
    this.resultRangeEndDt=null;
    if(evt.value=="Choose Date Range"){
      this.resultRangeStartDt=new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      this.resultRangeEndDt=new Date();
      this.showDateRange=true;
    }
  }

  populateTestType(){
    this.testTypeItem=[
      {value:'All',label:'All'},
      {value:'Individual',label:'Individual'},
      {value:'Profile',label:'Profile'}
    ];    
    return this.testTypeItem;    
  }

  populateResultType(){
    this.resultTypeItem=[
      {value:'All',label:'All'},
      {value:'Final',label:'Final'},
      {value:'Prelim',label:'Prelim'}
    ];   
    return this.resultTypeItem;
  }

  populateSignatureOptions(){
    this.signatureItem=[
      { label: 'Yes', value: 1 },
     { label: 'No', value: 0}
    ];
  }
//OneV-732258  Lab report pdf end


  populateModels(evt){
    this.getModelsParam.GETMODELS.equipmentTypeId=evt.value;
    this.selectedEquipmentTypeId=evt.value;
    let GETMODELS = this.getModelsParam;
      this._Modelservice.getModels(JSON.stringify(GETMODELS))
      .subscribe((modelRespose: any) => {
        this.modelItem=[];
        if(modelRespose.models!=null && modelRespose.models.length> 0){
          this.modelItem.push({label:"",value:null});
            for (let c of modelRespose.models) {
              c.ModelDetail=c.manufacturername+"-"+c.modelnumber;
              this.modelItem.push({ label:c.ModelDetail, value:c.modelid});
            }
          }
      });
  }

  populatePmInterval() {
    this.pmIntervalItem = [
      { value: 45, label: '45' },
      { value: 90, label: '90' },
      { value: 180, label: '180' },
      { value: 365, label: '365' }
    ];
    return this.pmIntervalItem;
  }

  populateEquipmentSubType(){
    this.getEquipmentSubTypeParam.GETEQUIPMENTSUBTYPES.equipmenttypeid=this.selectedEquipmentTypeId;
    let request = this.getEquipmentSubTypeParam;
    this._EquipmentService.getEquipmentSubtypes(JSON.stringify(request))
      .subscribe((equipmentSubTypeRespose: any) => {
        this.equipmentSubTypeItem=[];
        if(equipmentSubTypeRespose.equipmentSubType!=null && equipmentSubTypeRespose.equipmentSubType.length> 0){
          this.equipmentSubTypeItem.push({label:"",value:null});
            for (let c of equipmentSubTypeRespose.equipmentSubType) {
              this.equipmentSubTypeItem.push({ label:c.EquipmentSubTypeDescription, value:c.EquipmentSubTypeId});
            }
          }
       });
  }

  populatePac()
  {
    this.pacItem= [
      {value: null, label: ''},
      {value: 2, label: 'Portable RO Negative Residual Chemical Verification'},
      {value: 3, label: 'Portable RO Disinfection'},
      {value: 4, label: 'Dialysis Machine Negative Residual Chemical Verification'},
      {value: 5, label: 'Dialysis Machine Flow Path Disinfection'} ,
      {value: 6, label: 'Dialysis Machine Descaling'},
      {value: 7, label: 'Device Surface Cleaning and Disinfection'},
      {value: 8, label: 'Concentrate Wand Rinse/Disinfection'},
      {value: 9, label: 'Dialysis Machine Positive Chemical Verification'},
      {value: 10, label: 'Dialysis Machine AM Negative Residual Chemical Verification'},
      {value: 11, label: 'End of Day Hardness Testing'},
      {value: 12, label: 'CWP Chemical Disinfection'},
      {value: 13, label: 'POST Negative Chemical Residual and Consumption Verification'}
  ];
  return this.pacItem;
  }


  onDeviceChange(evt:any){
    if(evt.value === "All"){
      this.selectedDeviceIds=this.selectedDeviceIds.filter(x=>x.value==='All');
    }
    else{
     this.selectedDeviceIds=this.selectedDeviceIds.filter(x=>x.value!=='All');
    }
  }
  onResultTypeChange(event){
    this.showSignatureSection=false;    
    if(event.value === "All" ){
      this.printPDFSubHeader = "Final | Preliminary";
      this.hideStatus = false;
      if(this.selectedReportFormat=="PDF"){
        this.showSignatureSection=true;
        this.updateSigntureModel(true);
      }
    }else if(event.value === "Prelim"){
      this.printPDFSubHeader = "Preliminary";
      this.hideStatus = true;     
      this.updateSigntureModel(false); 
    }else{
      this.printPDFSubHeader = "Final";
      this.hideStatus = false;
      if(this.selectedReportFormat=="PDF"){
        this.showSignatureSection=true;
        this.updateSigntureModel(true);
      }
    }
  }


   checkRequiredFields() {
      //let reportId =document.getElementById('reportId').nodeValue;
      let  report=this.reportMenuStruct[Number(this.hiddenReportOrder)-1].reportFields.data;
      let currentSum = 0;
      let requiredSum = report.requiredSum;
       for(let countSelectedReportItem=0; countSelectedReportItem<this.reportMenuStruct[Number(this.hiddenReportOrder)-1].reportFields.recordscount;countSelectedReportItem++)
       {
        let inputType=report.inputparameterinputtype[countSelectedReportItem];
        let required = report.report_inputparameterrequired[countSelectedReportItem]
        if (required) {
                 let fieldId=  'report' + report.reportId + '_' + inputType;
                 let curVal="";
                if(inputType.toLowerCase()=="datebegin" || inputType.toLowerCase()=="dateend" || inputType.toLowerCase()=="startdate")
                 {
                   let cValue=(<HTMLElement>document.getElementById(fieldId));
                   curVal=cValue.getElementsByTagName("input")[0].value;
                 }
                 else if(inputType.toLowerCase()=="countbegin"||inputType.toLowerCase()=="countend" ||inputType.toLowerCase()=="serialnumber"||inputType.toLowerCase()=="equipmentid_text"){
                  curVal =(<HTMLInputElement>document.getElementById(fieldId)).value
                 }
                 else if(inputType.toLowerCase()=="equipmentids"){
                  curVal="";
                  if(this.selectedDeviceIds != null && this.selectedDeviceIds.length > 0){
                    curVal = this.selectedDeviceIds[0].label;
                  }
                 }
                  else
                  {
                    curVal="";
                    let sValue=(<HTMLElement>document.getElementById(fieldId));
                    if(sValue!=null && sValue!=undefined)
                    {
                      curVal=sValue.getElementsByTagName('input')[0].attributes["aria-label"].nodeValue;
                    }
                  }
                  curVal = curVal.trim();
                   if (curVal.length ||inputType.toLowerCase()=="userid") {
                       currentSum++;
                   }
               }

                if(currentSum >= requiredSum)
                {
                  document.getElementById('runReport').style.display='block';
                  document.getElementById('dvReportFormat').style.display='block';
                  if(this.hiddenIsPDFReportFormat && this.selectedReportFormat=="PDF"){
                    this.showSignatureSection=true;
                    this.updateSigntureModel(true);
                  }                  

               }
               else
               {
                  document.getElementById('runReport').style.display='none';
                  document.getElementById('dvReportFormat').style.display='none';
                  this.showSignatureSection=false;
                  this.updateSigntureModel(false);
               }
       }

       if(this.showDateRange){
        document.getElementById('runReport').style.display='none';
        document.getElementById('dvReportFormat').style.display='none';
        this.showSignatureSection=false;
        if(this.resultRangeStartDt!=null && this.resultRangeEndDt!=null && currentSum >= requiredSum){
          document.getElementById('runReport').style.display='block';
          document.getElementById('dvReportFormat').style.display='block';
          if(this.selectedReportFormat=="PDF"){
            this.showSignatureSection=true;
          }
        }

       }
       if(this.selectedResultType=="Prelim"){
        this.showSignatureSection=false;
        this.showSignatureSectionOnPDF=false;
       }


  }
  onReportFormatChange(event){
    this.selectedReportFormat = event.value;
    this.showSignatureSection=false;
    if(this.selectedReportFormat=="PDF"){
      this.showSignatureSection=true;
      this.updateSigntureModel(true);
    }
    if(this.selectedResultType == "Prelim"){
      this.showSignatureSection = false;
      this.updateSigntureModel(false);
  }
  }
  onRadioButtonChange() {
  this.showSignatureSectionOnPDF = this.signature.value
   
  }

  updateSigntureModel(isAllow:boolean){
    this.signature=this.radioButtons.find(x=>x.value==isAllow);
  }

  runReport() {
    this.showDateRageForPDF="";
    this.hideStatus = false;
    if(this.showDateRange == true){
      let startDate = this.datePipe.transform(this.resultRangeStartDt,"MM/dd/yyyy");
      let endDate = this.datePipe.transform(this.resultRangeEndDt,"MM/dd/yyyy");
      this.showDateRageForPDF =startDate +" - " + endDate;
    }

    if(this.selectedResultType === "Prelim"){
      this.hideStatus = true;
      this.printPDFSubHeader = "Preliminary";
    }
    else if(this.selectedResultType === "All" ){
      this.printPDFSubHeader = "Final | Preliminary";
    }else{
      this.printPDFSubHeader = "Final";     
    }


    let report = this.reportMenuStruct[Number(this.hiddenReportOrder) - 1].reportFields.data;
    let reportUrl = "/reports/runReport?";
    let reportId = report.reportId;
    reportUrl += 'reportId=' + reportId;
    reportUrl += '&reportFormat=' + this.selectedReportFormat;
    reportUrl += '&requestTimeout=120';
    reportUrl += '&reportName=' + encodeURIComponent(this.reportTitle);
    for (let countSelectedReportItem = 0; countSelectedReportItem < this.reportMenuStruct[Number(this.hiddenReportOrder) - 1].reportFields.recordscount; countSelectedReportItem++) {
      let inputType = report.inputparameterinputtype[countSelectedReportItem];
      let fieldId = 'report' + report.reportId + '_' + inputType;
      let curVal;
      if (inputType.toLowerCase() == "datebegin" || inputType.toLowerCase() == "dateend" || inputType.toLowerCase() == "startdate") {
        let cValue = (<HTMLElement>document.getElementById(fieldId));
        if(cValue!=undefined){
          curVal = cValue.getElementsByTagName("input")[0].value;
        }      

      }
      else if (inputType.toLowerCase() == "countbegin" || inputType.toLowerCase() == "countend" || inputType.toLowerCase() == "serialnumber" || inputType.toLowerCase() == "equipmentid_text") {
        curVal = (<HTMLInputElement>document.getElementById(fieldId)).value
      }
      else if (inputType.toLowerCase() === "userid") {
        curVal = this.userDetail.userId;
      }
      else {
        curVal = this.getDropDownSelectedValue(inputType.toLowerCase());
      }
      curVal = String(curVal).trim();
      if (curVal == '' || curVal == "undefined") {
        curVal = null;
      }

      if(this.hiddenIsPDFReportFormat && (inputType.toLowerCase() == "datebegin" || inputType.toLowerCase() == "dateend")){
        reportUrl=reportUrl;
      } 
      else{
        reportUrl += '&' + inputType + '=' + curVal;
      }
      
      if(inputType.toLowerCase() == "viewresultsby" && curVal=="Choose Date Range"){
        reportUrl += '&dateBegin' + '=' + this.datePipe.transform(this.resultRangeStartDt,"MM/dd/yyyy");
        reportUrl += '&dateEnd' + '=' + this.datePipe.transform(this.resultRangeEndDt,"MM/dd/yyyy");
      }
    }
    
    if (this.selectedReportFormat == "Excel") {
      this.downLoadExcelFile(reportId, reportUrl)
    }
    else if(this.selectedReportFormat == "PDF"){
      this.reportId = reportId;
      this.reportURL = reportUrl;
      this.showSignatureSectionOnPDF=false;
      if(this.showSignatureSection){
        this.showSignatureSectionOnPDF = this.signature.value;
      }      
      this.printPDF=true;
    }
    else{
      this.popupWin = window.open(reportUrl, "_blank");
    }

    
 //#region User Action Audit

 
 this._userService.logUserAction({
  userName: this.userDetail.userName,
  userAction: UserAction.BUTTON_CLICKED,
  screenName: ScreenName.REPORT,
  screenPath: location.pathname,
  key: 'Filter_String',//reportId,
  value: reportUrl,
  eventDescription: UserActionDescription.RUN_REPORT_CLICKED
});
//#endregion


  }

getDropDownSelectedValue(input)
{

let retrunValue;
switch(input){
        case('divisionmasterid'):
          retrunValue=this.selectedDivisionMasterId;
        break;
        case('regionmasterid'):
          retrunValue=this.selectedRegionmasterId;
        break;
        case('facilitymasterid'):
          retrunValue=this.selectedFacilityMasterId;
        break;
        case('equipmentid'):
          retrunValue=this.selectedEquipmentId;
        break;
        case('equipmenttypeid'):
          retrunValue=this.selectedEquipmentTypeId;
        break;
        case('equipmentstatusid'):
          retrunValue=this.selectedEquipmentStatusId;
        break;
        case('sqacodeid'):
          retrunValue=this.selectedsqaCode;
        break;
        case('pmreporttype'):
          retrunValue=this.SelectedPmReportType;
        break;
        case('groupbylocation'):
          retrunValue=this.selectedGroupLocation;
        break;
        case('modelid'):
          retrunValue=this.selectedModelId;
        break;
        case('pminterval'):
        retrunValue=this.selectedPmIntervalId;
        break;
        case('equipmentsubtypeid'):
        retrunValue=this.selectedEquipmentSubTypeId;
        break;
        case('pacid'):
        retrunValue=this.selectedPacId;
        break;
        case('equipmentids'):
        retrunValue=this.selectedDeviceIds.map(item => item.value).join();
        break;
        case('viewresultsby'):
        retrunValue=this.selectedViewResultBy;
        break;
        case('testtype'):
        retrunValue=this.selectedTestType;
        break;
        case('resulttype'):
        retrunValue=this.selectedResultType;
        break;
}
return retrunValue;
}



  //Start:Added By Harikesh on 05-Aug-2020
  public runReportHeaderItem:string;
  public groupColumns:string="";
  public reportFormat:string;
  public reportData:any;
  public objHeaderColumn: ReportHeaderColumn =new ReportHeaderColumn();
  public downLoadExcelFile(reportId:number,reportUrl:string)
  {
    let argList="";
    let arrQueryParam=reportUrl.split("?")
    if(arrQueryParam.length>0)
    {
      argList=arrQueryParam[1].replace(/&/g, '|');
    }
    let runReportParam=  {
      "GETREPORTREPORTID":
        {
          "reportId":reportId
        },
        "RUNREPORT":{
          "ReportID":reportId,
          "ParamList":argList
        }
    }
    if(runReportParam!=null)
    {
      //this.showReportLoader=true;
      runReportParam.GETREPORTREPORTID.reportId=reportId;
      runReportParam.RUNREPORT.ReportID=reportId;

      var request = runReportParam
      this._ReportsService.runReport(JSON.stringify(request))
          .subscribe((runReportResponse:any)=>
          {
            if(runReportResponse.errors!=null && runReportResponse.errors!=undefined)
            {
              if(this.popupWin!=null)
              {
                this.popupWin.close();
              }
              alert(runReportResponse.errors);
            }
            else
            {
              if(runReportResponse!=null){
                if(runReportResponse.GETREPORTREPORTID.length>0){
                  this.runReportHeaderItem=runReportResponse.GETREPORTREPORTID[0].reportRenderColumnList;
                  this.groupColumns=runReportResponse.GETREPORTREPORTID[0].reportGroupColumnList;
                  this.reportData=[];
                  var columnOrder=[];
                  var grouping=[];
                  for(let column of this.runReportHeaderItem.split(',')){
                    columnOrder.push(column);
                  }
                  if(this.groupColumns!=null || this.groupColumns!=undefined){
                  for(let groupColumn of this.groupColumns.split(',')){
                        grouping.push(groupColumn);
                    }
                  }
                  this.reportData.columnOrder=columnOrder;
                  this.reportData.columns=this.objHeaderColumn.columns;
                  this.reportData.groupColumns= grouping;
                }
                var report=[];
                if(runReportResponse.RUNREPORT.length>0){
                    for(let row of runReportResponse.RUNREPORT){
                      report.push({row});
                    }
                    var reportkeys=runReportResponse.RUNREPORT[0];

                    var keys = Object.keys(reportkeys);
                    for(let keyIndex=0; keyIndex<keys.length;keyIndex++)
                    {
                        var rColumn=this.reportData.columnOrder.filter(
                          x=>x.toLowerCase()===keys[keyIndex].toLowerCase());
                          if(rColumn.length>0)
                          {
                          let index= this.reportData.columnOrder.findIndex(x=>x==rColumn);
                            this.reportData.columnOrder[index]=keys[keyIndex];
                            //this.reportTableWidth+=Number(this.objHeaderColumn.columns[keys[keyIndex]].width);
                          }

                          if(this.reportData.groupColumns.length>0){
                          var rGrpColumn=this.reportData.groupColumns.filter(
                            x=>x.toLowerCase()===keys[keyIndex].toLowerCase());
                            if(rGrpColumn.length>0 && this.reportData.groupColumns!=null)
                            {
                            let grpColumnIndex= this.reportData.groupColumns.findIndex(x=>x==rGrpColumn);
                              this.reportData.groupColumns[grpColumnIndex]=keys[keyIndex];
                            }
                          }

                    }
                    this.reportData.report=report;

                }
              }
              if(this.hideStatus){
                const index = this.reportData.columnOrder.indexOf("Status");
                  if (index > -1) { 
                    this.reportData.columnOrder.splice(index, 1); 
                }
              }
              let reportData =
              {
                title: this.reportTitle,
                data: this.reportData.report==undefined || this.reportData.report==null?[]:this.reportData.report,
                columns: this.objHeaderColumn.columns,
                columnOrder:this.reportData.columnOrder,
                groupColumns:this.reportData.groupColumns
              }
              let dateTime = new Date()
              let fileName:string=this.reportTitle.trim().replace(/ /g,"_")+"_"+this.userDetail.userId+"_"+this.datePipe.transform(dateTime, "dd-MM-yy")+"-"+this.datePipe.transform(dateTime, "hh-mm-ss")+".report.xlsx"
              this._ReportsService.exportExcel(reportData,fileName);
              if(this.popupWin!=null)
              {
                this.popupWin.close();
              }
          }
      },
      (resp)=>
        {
          this.popupWin.close();
          this._messageService.showAlertMessage(resp.error.errors);
        }
      );
    }
  }
  
   //End:Added By Harikesh on 05-Aug-2020
   printPDFLoaded()
  {
    this.printPDF=false; 
    this.hideStatus = false;
    // this._loaderService.hide();     
  }  
}
